// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__iYIfp","content":"GlobalSearch_content__3BWZh"};